/**
 * Main Layout Component
 *
 * Wraps all pages with shared header and footer.
 */

import { Footer } from './Footer'
import { Header } from './Header'

interface LayoutProps {
	children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
	return (
		<div className="flex min-h-screen flex-col bg-background">
			<Header />
			<main className="flex-1">{children}</main>
			<Footer />
		</div>
	)
}

export default Layout
